import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, SegmentGroupResponseDataSchema } from "schema"
import z from "zod"

type Response = DataResponse<z.infer<typeof SegmentGroupResponseDataSchema>>

type Options = {
  id: string
  onSuccess?: (data: z.infer<typeof SegmentGroupResponseDataSchema>) => void
}

export function getSegmentGroupQueryKey(id: string) {
  return ["segment-group", id]
}

export function segmentGroupQuery({ id, onSuccess }: Options) {
  return queryOptions({
    queryKey: getSegmentGroupQueryKey(id),
    queryFn: async (): Promise<z.infer<typeof SegmentGroupResponseDataSchema>> => {
      const response = await axios.get<Response>(`/segments/groups/${id}`)

      onSuccess?.(response.data.data)

      return response.data.data
    },
  })
}
